module.exports = __webpack_public_path__ + "static/media/gear.9128f752.png";